<template>
  <div class="step__blocks">
    <div class="s-block">
      <div class="s-text">
        <div v-if="item.UF_DESCR_TITLE" class="s-text__description">{{ item.UF_DESCR_TITLE }}:</div>
        <div class="s-text__list" v-html="description"></div>
      </div>
      <div class="s-range">
        <div class="s-inputs__item-title">{{ item.UF_SIZE_TITLE }}:</div>
        <div class="s-range__slider">
          <div v-show="item.UF_BOTTOM_LIMIT && item.UF_TOP_LIMIT" class="s-range__left">
            <Veeno ref="veenoDoor" :connect="'lower'" :step="1" :handles="[door]" :range="rangeDoor" v-model="door" @change="setSelect"/>
            <div class="s-range__text">
              <div v-show="this.item.UF_BOTTOM_LIMIT" class="s-range__text-min">{{ Number(item.UF_BOTTOM_LIMIT) }} мм
              </div>
              <div v-show="this.item.UF_STANDART" class="s-range__text-standart" @click="reset('door')">Стандартное
                                                                                                        значение
              </div>
              <div v-show="this.item.UF_TOP_LIMIT" class="s-range__text-max">{{ Number(item.UF_TOP_LIMIT) }} мм
              </div>
            </div>
          </div>
          <div class="s-inputs">
            <div class="default-input">
              <input class="default-input__input" type="number" @change="inputDoor" v-model="doorInput">
              <label class="default-input__label">мм</label>
            </div>
          </div>
        </div>
      </div>

      <div class="s-range">
        <div class="s-inputs__item-title">{{ item.UF_SIZE_TITLE_2 }}:</div>
        <div class="s-range__slider">
          <div v-show="item.UF_BOTTOM_LIMIT_2 && item.UF_TOP_LIMIT_2" class="s-range__left">
            <Veeno ref="veenoPanel" :connect="'lower'" :step="1" :handles="[panel]" :range="rangePanel" v-model="panel" @change="setSelect"/>
            <div class="s-range__text">
              <div v-show="this.item.UF_BOTTOM_LIMIT_2" class="s-range__text-min">{{ Number(item.UF_BOTTOM_LIMIT_2) }}
                                                                                  мм
              </div>
              <div v-show="this.item.UF_STANDART_2" class="s-range__text-standart" @click="reset('panel')">Стандартное
                                                                                                           значение
              </div>
              <div v-show="this.item.UF_TOP_LIMIT_2" class="s-range__text-max">{{ Number(item.UF_TOP_LIMIT_2) }} мм
              </div>
            </div>
          </div>
          <div class="s-inputs">
            <div class="default-input">
              <input class="default-input__input" type="number" @change="inputPanel" v-model="panelInput">
              <label class="default-input__label">мм</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="s-img">
      <img :src="item.PICTURE.src" alt="Изображение" loading="lazy">
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import Veeno                  from "veeno";

export default {
  name       : "TwoSizesRangeStepTest",
  props      : ["number", "item", "parent", "template", "description"],
  components : {
    Veeno
  },
  data()
  {
    return {
      door       : 0,
      doorInput  : 0,
      panel      : 0,
      panelInput : 0,
      rangeDoor  : {
        "min" : Number(this.item.UF_BOTTOM_LIMIT) > 0 ? Number(this.item.UF_BOTTOM_LIMIT) : 0,
        "max" : Number(this.item.UF_TOP_LIMIT) > 0 ? Number(this.item.UF_TOP_LIMIT) : 1
      },
      rangePanel : {
        "min" : Number(this.item.UF_BOTTOM_LIMIT_2) > 0 ? Number(this.item.UF_BOTTOM_LIMIT_2) : 0,
        "max" : Number(this.item.UF_TOP_LIMIT_2) > 0 ? Number(this.item.UF_TOP_LIMIT_2) : 1
      }
    };
  },
  computed : {
    ...mapState([
      "moduleConfigurator"
    ])
  },
  watch    : {
    "door"()
    {
      this.doorInput = Math.round(this.door);
      this.SET_PALLET_DOOR(this.door);
    },
    "panel"()
    {
      this.panelInput = Math.round(this.panel);
      this.SET_PALLET_PANEL(this.panel);
    }
  },
  methods  : {
    ...mapActions([
      "SET_SELECT", "SET_DOOR", "SET_PANEL", "SET_PALLET_DOOR", "SET_PALLET_PANEL"
    ]),
    reset( str )
    {
      let slider   = str === "door" ? this.$refs.veenoDoor : this.$refs.veenoPanel;
      let standart = str === "door" ? this.item.UF_STANDART : this.item.UF_STANDART_2;
      slider.$el.noUiSlider.set(Number(standart));
      this.setSelect();
    },
    inputDoor()
    {
      this.doorInput
          = this.inputValue(this.doorInput, this.item.UF_BOTTOM_LIMIT, this.item.UF_TOP_LIMIT, this.$refs.veenoDoor);
    },
    inputPanel()
    {
      this.panelInput
          = this.inputValue(this.panelInput, this.item.UF_BOTTOM_LIMIT_2, this.item.UF_TOP_LIMIT_2, this.$refs.veenoPanel);
    },
    inputValue( input, min, max, ref )//при вводе значения провеяем на min и max
    {
      input = Number(input);
      if(parseInt(input) > parseInt(max))
      {
        window.toast.error("Максимальное значение: " + max);
        input = parseInt(max);
      }
      if(parseInt(input) < parseInt(min))
      {
        window.toast.error("Минимальное значение: " + min);
        input = parseInt(min);
      }
      input = Math.round(input);
      ref.$el.noUiSlider.set(input);
      this.setSelect();
      return input;
    },
    setSelect()
    {
      if(this.$refs.veenoDoor)
      {
        this.$refs.veenoDoor.$el.noUiSlider.set(Number(this.door));
      }
      if(this.$refs.veenoPanel)
      {
        this.$refs.veenoPanel.$el.noUiSlider.set(Number(this.panel));
      }

      this.SET_SELECT({
        index : parseInt(this.number) - 1,
        name  : parseInt(this.door) + " мм X " + parseInt(this.panel) + " мм",
        id    : this.item["ID"]
      });

      this.checkDoor();
      this.checkPanel();
    },
    checkDoor()
    {
      if(parseInt(this.item.UF_CHANGE_DOOR) > 0)
      {
        this.SET_DOOR(parseInt(this.door) - parseInt(this.item.UF_CHANGE_DOOR));
      }
      else if(parseInt(this.item.UF_CHANGE_DOOR) === 0)
      {
        this.SET_DOOR(0);
      }
    },
    checkPanel()
    {
      if(parseInt(this.item.UF_CHANGE_PANEL) > 0)
      {
        this.SET_PANEL(parseInt(this.panel) - parseInt(this.item.UF_CHANGE_PANEL));
      }
      else if(parseInt(this.item.UF_CHANGE_PANEL) === 0)
      {
        this.SET_PANEL(0);
      }
    }
  },
  created()
  {
    if(this.moduleConfigurator.pallet.door > 0)
    {
      this.door = this.moduleConfigurator.pallet.door;
    }
    else
    {
      this.door  = parseInt(this.item.UF_STANDART);
    }
    if(this.moduleConfigurator.pallet.panel > 0)
    {
      this.panel = this.moduleConfigurator.pallet.panel;
    }
    else
    {
      this.panel  = parseInt(this.item.UF_STANDART_2);
    }
    if(!this.moduleConfigurator.steps[this.number - 1]["showNext"])
    {
      this.setSelect();
    }
  }

};
</script>

<style scoped>

</style>